<template>
  <div class="flex min-h-full flex-col">
    <TillRouteTabs class="shrink-0" />

    <div
      class="flex h-full flex-1 flex-col justify-end overflow-y-auto"
    >
      <div
        class="flex flex-1 flex-col justify-center space-y-1 px-6"
      >
        <!-- mt-5 is lineheight of textarea in NoteInput, to account for second, empty line -->
        <CustomAmountDisplay
          :value="amountInput"
          class="mt-5 w-full"
        />

        <NoteInput v-model="note" />
      </div>
      <BaseNumpad v-model="amountInput" />
      <div class="space-y-3 p-4">
        <div class="flex space-x-1">
          <ActionButtonPrimary
            :disabled="amountInput === 0"
            class="grow"
            @click="handlePay('card')"
          >
            <div
              class="flex flex-row flex-nowrap items-center justify-center text-lg font-medium"
            >
              <IconCard class="mr-2" />
              <span> Pay with card </span>
            </div>
          </ActionButtonPrimary>

          <ActionButtonPrimary
            v-if="cardholderNotPresentEnabled"
            :disabled="amountInput === 0"
            @click="handlePay('CNP')"
          >
            <div
              class="flex flex-row flex-nowrap items-center justify-center text-lg font-medium"
            >
              <IconPhoneFilled class="mr-2" />
              <span> CNP </span>
            </div>
          </ActionButtonPrimary>
        </div>

        <ActionButtonSecondary
          v-if="isCashEnabled"
          :disabled="amountInput === 0"
          class="block w-full text-base"
          @click="handlePay('cash')"
        >
          Pay with cash
        </ActionButtonSecondary>
      </div>
    </div>
  </div>

  <!-- We don't want to use drawer state to open/close as want a full component unmount -->
  <template v-if="paymentResponse && paymentMethod">
    <SimplePaymentDrawer
      :invoice="paymentResponse.invoice"
      :order-id="paymentResponse.id"
      :method="paymentMethod"
      @close="onClosePaymentDrawer"
    />
  </template>
</template>

<script setup lang="ts">
import { ILogger } from "@/androidPlugins/ILogger"
import { createSimplePayment } from "@/services/createSimplePayment"
import type { CreateSimplePaymentResponse } from "@/services/createSimplePayment"

const { isCashEnabled } = useTenant()
const { cardholderNotPresentEnabled } =
  useCardholderNotPresent()

const amountInput = ref(0)
const note = ref("")
const paymentMethod = ref<"cash" | "card" | "CNP" | null>(
  null
)
const paymentResponse =
  ref<CreateSimplePaymentResponse | null>(null)
const { startLoading, stopLoading } =
  usePageBlockingLoading()

const handlePay = async (
  method: "cash" | "card" | "CNP"
) => {
  ILogger.logToDetailLog({
    message: "SimplePayment: Click Pay",
  })

  paymentMethod.value = method

  startLoading()
  try {
    const response = await createSimplePayment({
      note: note.value,
      amountGross: amountInput.value,
      amountGratuity: 0,
    })

    paymentResponse.value = response
    amountInput.value = 0
    note.value = ""
  } catch {
    toast.error("Initialising payment went wrong")
  } finally {
    stopLoading()
  }
}

const onClosePaymentDrawer = () => {
  paymentMethod.value = null
  paymentResponse.value = null
}
</script>
